import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  min-width: 300px;
  flex-direction: column;
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
`;

export const StyledHeadingWrapper = styled.div`
  display: flex;
`;

export const StyledHistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${utils.rem(theme.Spacing.Size.XXSmall)} 0`};
  max-height: ${({ theme }) => `${utils.rem(theme.Modal.Size.Small)}`};
  overflow-y: auto;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.Scrollbar.Default}
`;

export const StyledEmptyHistory = styled.div`
  text-align: center;
`;
